export const version = "ethers/5.0.26";
//# sourceMappingURL=_version.js.map